import {useEffect,useState} from "react";
import {db} from "../firebase";

import {
collection,
getDocs
} from "firebase/firestore";

import {Link} from "react-router-dom";

import "./Shop.css";
import BackButton from "../components/BackButton";


function Shop(){


const [products,setProducts]=useState([]);

const [page,setPage]=useState(1);


const perPage=6;



useEffect(()=>{


const load=async()=>{


const snap=await getDocs(
collection(db,"products")
);



setProducts(

snap.docs.map(doc=>({

id:doc.id,
...doc.data()

}))

);


};


load();


},[]);





const totalPages=Math.ceil(
products.length / perPage
);



const start=(page-1)*perPage;



const current=products.slice(
start,
start+perPage
);




return(

<div className="shop-page">


<BackButton/>


<h1 className="shop-title">
ALL PRODUCTS
</h1>



<div className="shop-grid">


{

current.map(product=>(


<div 
className="shop-card"
key={product.id}
>



<Link to={`/product/${product.id}`}>



<img
src={product.images?.[0] || "/no-image.png"}
alt={product.name}
/>



<h2>
{product.name}
</h2>


</Link>



<p>
${product.price}
</p>


</div>


))


}


</div>





{/* Pagination */}


<div className="pagination">



<button

className="page-arrow"

disabled={page===1}

onClick={()=>setPage(page-1)}

>

←

</button>




{

Array.from(
{length:totalPages},
(_,index)=>(

<button

key={index}

className={
page===index+1
?
"active-page"
:
""
}

onClick={()=>setPage(index+1)}

>

{index+1}

</button>


))

}




<button

className="page-arrow"

disabled={page===totalPages}

onClick={()=>setPage(page+1)}

>

→

</button>



</div>




</div>


)

}


export default Shop;